import * as React from 'react'

import { ResponseRoleList } from '@/schema'

import { ERoleType, EStepperType } from '../../constants'
import { useUserManagementStore } from '../../store'

import { OrgAdminAccess } from './OrgAdminAccess'
import { ProjectAccess } from './ProjectAccess'

type AssignedAccessProps = {
  roles: ResponseRoleList[]
  stepId: string
}

const AssignedAccess: React.FC<AssignedAccessProps> = ({ roles, stepId }) => {
  const { addUsersFormData, setAddUsersFormData } = useUserManagementStore()

  // Whether the step is active
  const isActive = React.useMemo(() => {
    return stepId === EStepperType.ASSIGNED_ACCESS
  }, [stepId])

  const isInviteOrgAdmin = React.useMemo(() => {
    const orgAdminRole = roles.find(
      (role) => role.role_name === ERoleType.ORGANIZATION_ADMIN
    )

    if (orgAdminRole) return addUsersFormData.roleId === orgAdminRole.id
    return false
  }, [addUsersFormData.roleId, roles])

  const setSelectedProjects = React.useCallback(
    (projects: string[]) => setAddUsersFormData({ assignedProjects: projects }),
    [setAddUsersFormData]
  )

  if (!isActive) return null
  if (isInviteOrgAdmin) return <OrgAdminAccess />
  return (
    <ProjectAccess
      selectedProjects={addUsersFormData.assignedProjects || []}
      setSelectedProjects={setSelectedProjects}
    />
  )
}

const MemoizedAssignedAccess = React.memo(AssignedAccess)
MemoizedAssignedAccess.displayName = 'AssignedAccess'

export { MemoizedAssignedAccess as AssignedAccess }
